export default "__VITE_ASSET__cbe6223e__"